import format from 'date-fns/format';

import { parseDate } from '../../../utils/datetime';

export const formatDate = (date: string | Date) => {
  const d =
    typeof date === 'string' ? new Date(toClientUTCDateFormat(date)) : date;
  return format(d, 'MMMM dd, yyyy');
};

export const formatUpcomingLaunchDate = (launchDate: string) => {
  return `${format(
    new Date(toClientUTCDateFormat(launchDate)),
    'iiii dd, MMMM - HH-mm',
  )} GMT`;
};

export const formatLaunchDate = (launchDate: string | Date) => {
  return `${format(
    launchDate instanceof Date
      ? launchDate
      : new Date(toClientUTCDateFormat(launchDate)),
    'MMMM dd, yyyy - HH-mm',
  )} GMT`;
};

export const isLaunchDateUpcoming = (launchDate: string) => {
  const parsedDate = parseDate(launchDate);

  if (parsedDate === null) {
    // If there's a parsing error we should still let users subscribe.
    return true;
  }

  return new Date() < parsedDate;
};

export const isLaunchDateInPast = (launchDate: string) => {
  const parsedDate = parseDate(launchDate);

  if (parsedDate === null) {
    // If there's a parsing error, we shouldn't let users purchase.
    return false;
  }

  return new Date() > parsedDate;
};

export const toClientUTCDateFormat = (dateString: string) => {
  return String(`${dateString}Z`).replace(' ', 'T');
};
